import * as api from "../http/apis/credit-assessment";
import { CreditAssessmentSignResponse } from "./sign-response";
import { CreditAssessmentStatusResponse } from "./status-response";
import { validateInquiry } from "./validator";
export const newCase = (request) => {
    validateInquiry(request);
    return api.newCase(request);
};
export const getStatus = (caseId) => api
    .getStatus(caseId)
    .then((response) => new CreditAssessmentStatusResponse(response));
export const signCase = (request) => api
    .signCase(request)
    .then((response) => new CreditAssessmentSignResponse(response, request));
export const cancelSigning = (caseId) => api.cancelSigning(caseId);
export const accept = (caseId) => api.accept(caseId);
export const decline = (caseId) => api.decline(caseId);
